import React from 'react';
import { Field, Form, Formik } from 'formik';
import FormikFieldInputGroup from './formik/FormikFieldInputGroup';
import { SubmitButton } from '../buttons/SubmitButton';
import { CancelButton } from '../buttons/CancelButton';
import FormikSelectInputGroup from './formik/FormikSelectInputGroup';
import FormLabelControl from './FormLabelControl';
import { FormikDateTimePickerGroup } from './formik/FormikDateTimePickerGroup';
import './BDSMForm.css';
import { FormikSearchSelectInputGroup } from './formik/FormikSearchSelectInputGroup';
import { FormikSearchMultiSelectInputGroup } from './formik/FormikSearchMultiSelectInputGroup';

export class BDSMForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = { form: this.props.form };
    }

    componentDidUpdate(prevProps, prevState, sn) {
        if (prevProps !== this.props) {
            this.setState({ form: this.props.form });
        }
    }

    resolveField = (name, index) => {
        let fieldComponent;
        switch (this.state.form.types[index]) {
            case 'select':
                fieldComponent = (
                    <Field
                        as='select'
                        key={name}
                        className={this.state.form.className}
                        name={name}
                        labelText={this.state.form.label[index]}
                        data={this.state.form.selectData[index]}
                        component={FormikSelectInputGroup}
                    />
                );
                break;
            case 'searchSelect':
                fieldComponent = (
                    <Field
                        as='select'
                        key={name}
                        className={this.state.form.className}
                        name={name}
                        labelText={this.state.form.label[index]}
                        data={this.state.form.selectData[index]}
                        component={FormikSearchSelectInputGroup}
                    />
                );
                break;
            case 'searchMultiSelect':
                fieldComponent = (
                    <Field
                        as='select'
                        key={name}
                        className={this.state.form.className}
                        name={name}
                        labelText={this.state.form.label[index]}
                        data={this.state.form.selectData[index]}
                        component={FormikSearchMultiSelectInputGroup}
                    />
                );
                break;
            case 'textarea':
                fieldComponent = (
                    <Field
                        isTextArea={true}
                        key={name}
                        className={this.state.form.className}
                        name={name}
                        labelText={this.state.form.label[index]}
                        type={this.state.form.types[index]}
                        component={FormLabelControl}
                    />
                );
                break;
            case 'datePicker':
                fieldComponent = (
                    <Field
                        key={name}
                        className={this.state.form.className}
                        name={name}
                        labelText={this.state.form.label[index]}
                        type={this.state.form.types[index]}
                        data={this.state.form.selectData[index]}
                        component={FormikDateTimePickerGroup}
                    />
                );
                break;
            default:
                fieldComponent = (
                    <Field
                        key={name}
                        className={this.state.form.className}
                        name={name}
                        labelText={this.state.form.label[index]}
                        type={this.state.form.types[index]}
                        component={FormikFieldInputGroup}
                    />
                );
                break;
        }
        return fieldComponent;
    };

    render() {
        return (
            <Formik
                initialValues={this.state.form.initValues}
                enableReinitialize
                onSubmit={(record) => this.state.form.onSubmit(record)}
                validationSchema={this.state.form.validationSchema}
            >
                {() => {
                    return (
                        <Form className={this.state.form.inputFieldsClass}>
                            {this.state.form.fieldNames.map((name, index) => {
                                return <div key={'field' + index}>
                                    {this.resolveField(name, index)}
                                </div>;
                            })}
                            <div className='center'>
                                <SubmitButton />
                                {this.state.form.hideCancel
                                    ? <></>
                                    : <CancelButton onClick={() => this.state.form.onCancel()} />
                                }
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        );
    }
}